import Axios from 'axios';

import { errorLog } from '@uderly/react-uderly-ui/api';
import Settings from "../app/settings";
import DeviceUnregisterRequest from '../models/DeviceUnregisterRequest';
import DeviceRegistrationRequest from '../models/DeviceRegistrationRequest';

export const registerDevice = async (request: DeviceRegistrationRequest) => {
  return await Axios.post(`${Settings.apiUrl}/devices/register`, request)
    .catch((error) => {
      console.log('error ' + error);
      errorLog(error);
      return error;
    });
}

export const unregisterDevice = async (request: DeviceUnregisterRequest) => {
  const config = {
    data: request
  };

  return await Axios.delete(`${Settings.apiUrl}/devices/unregister`, config)
    .catch((error) => {
      console.log('error ' + error);
      errorLog(error);
      return error;
    });
}